<?xml version="1.0" encoding="UTF-8"?>
<svg width="14px" height="17px" viewBox="0 0 14 17" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g fill="#FFFFFF" fill-rule="nonzero">
            <rect id="Rectangle" x="2.4" y="2.4" width="10.8" height="14.4" rx="1.8"></rect>
            <path d="M0.6,13.8 C0.26862915,13.8 0,13.5313708 0,13.2 L0,3 C0.0019836698,1.34396811 1.34396811,0.0019836698 3,0 L9.6,0 C9.93137084,0 10.2,0.268629155 10.2,0.6 C10.2,0.931370845 9.93137084,1.19999999 9.6,1.2 L3,1.2 C2.00588745,1.2 1.2,2.00588745 1.2,3 L1.2,13.2 C1.2,13.5313708 0.93137085,13.8 0.6,13.8 Z" id="Path"></path>
        </g>
    </g>
</svg>